<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Policy Type</span>
        <span v-copy="getAllOptionName23('plan_type', quoteForm.plan_type)">{{ getAllOptionName23('plan_type', quoteForm.plan_type) }}</span>
      </div>
      <div class="tr">
        <span>Coverage</span>
        <span v-copy="getAllOptionName23('area_of_travel', quoteForm.area_of_travel)">{{ getAllOptionName23('area_of_travel', quoteForm.area_of_travel) }}</span>
      </div>
      <div
        v-if="quoteForm.class_type==1"
        class="tr">
        <span>Departure and Return Date</span>
        <span v-copy="`${quoteForm.pcy_cmnt_dt} - ${quoteForm.pcy_expry_dt}`">{{ quoteForm.pcy_cmnt_dt }} - {{quoteForm.pcy_expry_dt}}</span>
      </div>
      <div
        v-if="quoteForm.plan_type==2"
        class="tr">
        <span>Effective Date</span>
        <span v-copy="`${quoteForm.pcy_cmnt_dt} `">{{ quoteForm.pcy_cmnt_dt }}</span>
      </div>

      <div class="tr">
        <span>Cover Type</span>
        <span v-copy="getAllOptionName23('class_type', quoteForm.class_type)">{{ getAllOptionName23('class_type', quoteForm.class_type) }}</span>
      </div>
      <div
        v-if="quoteForm.class_type==1&&![1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <span v-copy="getAllOptionName23('traveler_num', quoteForm.no_of_traveler)">{{ getAllOptionName23('traveler_num', quoteForm.no_of_traveler) }}</span>
      </div>
      <!--      <div-->
      <!--        v-if="quoteForm.class_type==1"-->
      <!--        class="tr">-->
      <!--        <span>Area of Travel</span>-->
      <!--        <span>{{ getAllOptionName23('area_of_travel', quoteForm.area_of_travel) }}</span>-->
      <!--      </div>-->
      <div
        v-if="quoteForm.class_type!==1||[1,3,4].includes(quoteForm.plan_type)"
        class="tr">
        <span>No. of Traveller(s)</span>
        <!--        <span  v-copy="`${quoteForm.no_of_senior} Senior ${quoteForm.no_of_adult} Adult ${getAllOptionName23('child_num', quoteForm.no_of_child)} Child`">{{ quoteForm.no_of_adult }} Adult {{ getAllOptionName23('child_num', quoteForm.no_of_child) }} Child</span>-->
        <span  v-copy="`${traveller}`">{{ traveller }}</span>
      </div>
      <!--      <div-->
      <!--        v-if="quoteForm.class_type!==1"-->
      <!--        class="tr">-->
      <!--        <span>Number of Child</span>-->
      <!--        <span>{{ getAllOptionName23('child_num', quoteForm.no_of_child) }}</span>-->
      <!--      </div>-->
      <!--      <div class="tr">-->
      <!--        <span>Number of Child</span>-->
      <!--        <span>{{ getAllOptionName23('child_num', quoteForm.no_of_child) }}</span>-->
      <!--      </div>-->
      <div class="tr">
        <span>
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName23('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    },
    traveller(){
      const { class_type, no_of_traveler, no_of_adult, no_of_child, plan_type,no_of_senior } = this.quoteForm
      const signAdult = 'Adult(s)'
      const signSenior = 'Elderly'
      const signChild = '(ren)'
      let child = no_of_child?`${no_of_child} ${signChild}`:''
      let senior = no_of_senior?`${no_of_senior} ${signSenior}  `:''
      let adult = no_of_adult?`${no_of_adult} ${signAdult} `:''
      let all_text = `${senior} ${adult} ${child}`
      return all_text
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
</style>
